// extracted by mini-css-extract-plugin
export var buttonGroup = "partnersCarousel-module--buttonGroup--q5iUo";
export var carousel = "partnersCarousel-module--carousel--qlSts";
export var item = "partnersCarousel-module--item--5Uxci";
export var leftArrow = "partnersCarousel-module--leftArrow--TP73f";
export var partnersCarousel = "partnersCarousel-module--partnersCarousel--ZSjSs";
export var photoSliderImg = "partnersCarousel-module--photoSliderImg--eBf-2";
export var rightArrow = "partnersCarousel-module--rightArrow--NTjQ0";
export var sbShowMain = "partnersCarousel-module--sb-show-main--Wcii4";